import { render, staticRenderFns } from "./AdsView.vue?vue&type=template&id=2f21a401&scoped=true"
import script from "./AdsView.vue?vue&type=script&lang=js"
export * from "./AdsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21a401",
  null
  
)

export default component.exports